
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle({
    contentWrapper: {
        display: "flex",
        marginLeft: 50,
        paddingLeft: 40,
        paddingTop: 10,
        marginRight: 63
    },
    footer: {
        flexDirection: "row",
        alignSelf: "flex-end",
        width: 220,
        height: 44,
        marginTop: 82,
    },
    inputWrapper: {
        marginLeft: "20%"
    },
    panWrapper: {
        flexDirection: "row",
        marginLeft: 0,
        justifyContent: "space-between",
        marginTop: 32
    },
    validateButtonWrapper: {
        height: 44,
        width: 224,
        borderRadius: 25,
    },
    custInfoWrapper: {
        flex: 1,
        gap: 15,
        marginTop: 58
    },
    infoWrapper: {
        flexDirection: "row",
        gap: 70,
        position: "relative",
    },
    overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
    },
},
    {
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: {},
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            inputWrapper: {
                marginLeft: 0,
                marginTop: 63
            },
            contentWrapper: {
                paddingLeft: 0,
                marginLeft: 30,
                flexDirection: "column"
            },
            panWrapper: {
                flexDirection: "column",
                marginLeft: 0,
            },
            validateButtonWrapper: {
                alignSelf: "center",
                marginTop: 10,
            },
            infoWrapper: {
                flexDirection: "column",
                gap: 10,
            },
            custInfoWrapper: {
                marginTop: 30
            },
            footer: {
                alignSelf: "center",
                marginTop: 30,
            },
        }
    })

export default useStyles;